import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output, Input } from '@angular/core';

import { IconComponent } from '@mode/capra';

@Component({
  standalone: true,
  selector: 'mode-star',
  imports: [CommonModule, IconComponent],
  templateUrl: './star.component.html',
  styleUrls: ['./star.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StarComponent {
  @Output() highlightedChanged = new EventEmitter<void>();
  @Input() highlighted = false;
}
